import { useSelector } from 'react-redux'
import { isAdminGatewayUserSelector } from 'selectors/userSelectors'

export const TradingUserOnly: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const isAdmin = useSelector(isAdminGatewayUserSelector)
  return isAdmin ? null : children
}
